export default __webpack_public_path__ + "static/media/Logo2.4c20eaaf.png";